import React, { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ButtonBase from '@mui/material/ButtonBase'
import Paper from '@mui/material/Paper'
import { IKnockStatusIcon } from '@user/store/knockStatus/typings'
import { useKnockStatusIcons } from '@user/components/KnockStatus/hooks'
import Alert from '@mui/material/Alert'

interface IconSelectorProps {
  value: IKnockStatusIcon | null
  onChange: (icon: IKnockStatusIcon) => void
  error?: string
}

export const IconSelector: FC<IconSelectorProps> = ({
  value,
  onChange,
  error,
}) => {
  const { getIcon } = useKnockStatusIcons()

  // Icons 1 to 20 from KnockStatusIcon enum
  const iconList = Array.from(
    { length: 20 },
    (_, i) => (i + 1) as IKnockStatusIcon,
  )

  return (
    <Box>
      <Typography variant="subtitle3">Add Icon*</Typography>
      {error && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      )}
      <Box
        sx={{
          mt: 1,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 1,
        }}
      >
        {iconList.map((icon) => (
          <Paper
            key={icon}
            variant="outlined"
            sx={{
              p: 0,
              border:
                value === icon ? '1px solid #0D47A1' : '1px solid #E0E0E0',
              backgroundColor: value === icon ? '#F0F7FF' : 'white',
              borderRadius: '4px',
              overflow: 'hidden',
              transition: 'all 0.2s',
            }}
          >
            <ButtonBase
              onClick={() => onChange(icon)}
              sx={{
                width: '100%',
                height: 50,
                color: '#05274C',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
                p: 1.5,
              }}
            >
              {getIcon(icon)}
            </ButtonBase>
          </Paper>
        ))}
      </Box>
    </Box>
  )
}
